<template>
  <div class="flex flex-col items-end ss xxx">
    ABOUT
  </div>
</template>